import { getDateKey } from '../games/WordMaster/wordMasterUtils';
import { COZY_HUB_GAMES } from '../data/cozyHubGames';

const WORD_MASTER_GUEST_KEY = 'wordMasterDailyPlayed';
const WORD_SQUARE_TOMORROW_PREFIX = 'full_crossword_tomorrow_msg_';

/** UTC YYYY-MM-DD for Word Square daily ids (`ws_YYYY-MM-DD`). */
export function wordSquareUtcDateId(d = new Date()) {
  const utc = new Date(d.getTime());
  const y = utc.getUTCFullYear();
  const m = String(utc.getUTCMonth() + 1).padStart(2, '0');
  const day = String(utc.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function wordSquareDailyPuzzleId(d = new Date()) {
  return `ws_${wordSquareUtcDateId(d)}`;
}

function emptyCompletion() {
  return Object.fromEntries(COZY_HUB_GAMES.map((g) => [g.id, false]));
}

/**
 * Signed-in completion from Firestore profile fields.
 * @param {object|null|undefined} profile
 * @param {Date} [now]
 */
export function hubCompletionFromProfile(profile, now = new Date()) {
  const completion = emptyCompletion();
  if (!profile) return completion;

  const today = getDateKey(now);
  const wordSquareId = wordSquareDailyPuzzleId(now);
  const done = (date) => date != null && date === today;

  const wm = profile.wordMasterStats ?? {};
  const lh = profile.letterHiveStats ?? {};
  const wr = profile.wordRungsStats ?? {};
  const xs = profile.fullCrosswordStats ?? {};
  const cw = profile.crosswordStats ?? {};

  completion.wordMaster = done(wm.lastDailyCompletedDate);
  completion.letterHive = done(lh.lastDailyCompletedDate);
  completion.wordRungs = done(wr.lastDailyCompletedDate);
  completion.wordSquare = xs.lastCompletedPuzzleId === wordSquareId;
  completion.hiddenWords = done(cw.lastDailyCompletedDate);

  return completion;
}

/**
 * Guest/local overrides (Word Master + Word Square).
 * @param {Date} [now]
 */
export function hubGuestCompletionOverrides(now = new Date()) {
  if (typeof localStorage === 'undefined') {
    return { wordMaster: false, wordSquare: false };
  }
  const today = getDateKey(now);
  const wmStored = localStorage.getItem(`${WORD_MASTER_GUEST_KEY}_${today}`);
  const wsKey = `${WORD_SQUARE_TOMORROW_PREFIX}${wordSquareUtcDateId(now)}`;
  const wsDone = localStorage.getItem(wsKey) === '1' || localStorage.getItem(wsKey) === 'true';

  return {
    wordMaster: wmStored != null,
    wordSquare: wsDone,
  };
}

/**
 * @param {object|null|undefined} profile
 * @param {boolean} signedIn
 * @param {Date} [now]
 */
export function hubDailyCompletion(profile, signedIn, now = new Date()) {
  const base = hubCompletionFromProfile(profile, now);
  if (signedIn) return base;

  const guest = hubGuestCompletionOverrides(now);
  return {
    ...base,
    wordMaster: base.wordMaster || guest.wordMaster,
    wordSquare: base.wordSquare || guest.wordSquare,
  };
}
